import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, CircularProgress } from '@mui/material'

export interface CancelSubscriptionModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading: boolean
}

export const CancelSubscriptionModal: React.FC<CancelSubscriptionModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 900 }}>Cancel Plan</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          Cancelling plan stops recurring charges from the next cycle. You'll retain full access to all your plan features until the end of your current billing period.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, flexDirection: { xs: 'column-reverse', sm: 'row' }, gap: { xs: 1, sm: 0 } }}>
        <Button onClick={onClose} color="inherit" disabled={loading} sx={{ width: { xs: '100%', sm: 'auto' } }}>
          Keep My Plan
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ fontWeight: 800, width: { xs: '100%', sm: 'auto' } }}
        >
          {loading ? 'Cancelling...' : 'Cancel Renewal'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
